import { render } from "./Navbar.vue?vue&type=template&id=5ac3b153&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=5ac3b153&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-5ac3b153"

export default script